import { Card, Stack, Text, textVariants } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { bulletStyles } from '../../../../utils/styleUtils';
import type { SnowplowEventDataType } from '../../models';
import CaretButtonWithDrawer from './CaretButtonWithDrawer';

interface MedicalCertificateProps {
  snowplow: SnowplowEventDataType;
}

const MedicalCertificate = ({ snowplow }: MedicalCertificateProps) => {
  const { t } = useTranslation();
  const { p } = useProperty();
  const medCertUrl = p('OrderDetails.MedicalCertificate.Url');

  return (
    <CaretButtonWithDrawer
      dataTestId="medical-certificate-button"
      drawerContent={
        <Card data-testid="medical-certificate-drawer-content">
          <Stack>
            <Text asHtml className={bulletStyles()}>
              {t('OrderDetails.MedicalCertificate.Description')}
            </Text>
            <a href={medCertUrl} rel="noreferrer" target="_blank">
              {t('OrderDetails.MedicalCertificate.Link.Text')}
            </a>
          </Stack>
        </Card>
      }
      drawerTitle={t('OrderDetails.MedicalCertificate.Title')}
      snowplow={{
        category: snowplow.category,
        label: snowplow.label,
      }}
    >
      <Text variant={textVariants._16_BOLD}>{t('OrderDetails.MedicalCertificate.Title')}</Text>
    </CaretButtonWithDrawer>
  );
};

export default MedicalCertificate;
